<template>
    <div class="company-portal-spa-layout grid h-screen bg-ds-primary-100">
        <SideNavPanel class="area-nav-rail">
            <RouterView name="sideNav" />
        </SideNavPanel>

        <div class="area-top">
            <SideNavToggleButton
                :class="{ hidden: isLoginRoute || isIntegrationRoute }"
                @click="companyNavigationStore.toggleSideNav"
            />
            <slot name="top">
                <strong>area top</strong>
            </slot>
        </div>

        <div class="area-tab-nav">
            <RouterView
                class="pt-8"
                name="header"
            />

            <RouterView
                class="mt-6"
                name="tabNav"
            />
        </div>

        <div class="area-content isolate grid overflow-auto bg-white">
            <RouterView
                class="area-inner-nav mr-6"
                name="innerSideNav"
            />

            <RouterView class="area-inner-content" />
        </div>
    </div>
</template>

<script setup lang="ts">
import SideNavPanel from '@/components/Navigation/side-nav/SideNavPanel.vue';
import SideNavToggleButton from '@/components/Navigation/side-nav/SideNavToggleButton.vue';
import { INTEGRATION_ROUTES_INJECTION_KEY, NO_SIDEBAR_ROUTES_INJECTION_KEY } from '@/injection-keys';
import type { CompanyPortalLaravelLayoutProps } from '@/layouts/company-portal-layout.types';
import { useCompanyNavigationStore } from '@/stores/company/company-navigation.store';
import { computed, inject } from 'vue';
import { useRoute } from 'vue-router';

defineProps<CompanyPortalLaravelLayoutProps>();

const route = useRoute();
const noSidebarRoutes = inject(NO_SIDEBAR_ROUTES_INJECTION_KEY, []);
const integrationRoutes = inject(INTEGRATION_ROUTES_INJECTION_KEY, []);
const isLoginRoute = computed<boolean>(() => noSidebarRoutes.some(val => route.path.includes(val)));
const isIntegrationRoute = computed<boolean>(() => integrationRoutes.some(val => route.path.includes(val)));

const companyNavigationStore = useCompanyNavigationStore();
</script>

<style scoped lang="scss">
.company-portal-spa-layout {
    grid-template-rows: max-content max-content 1fr;
    grid-template-columns: max-content 1fr;
    grid-template-areas:
        'nav-rail top'
        'nav-rail tab-nav'
        'nav-rail content';

    @media screen and (min-width: 768px) {
        grid-template-areas:
            'top      top'
            'nav-rail tab-nav'
            'nav-rail content';
    }
}

.area-nav-rail {
    grid-area: nav-rail;
}

.area-top {
    @apply flex items-center gap-2;
    grid-area: top;
}

.area-tab-nav {
    @apply bg-white;

    grid-area: tab-nav;
}

.area-content {
    grid-area: content;

    grid-template-rows: 1fr;
    grid-template-columns: max-content 1fr;
    grid-template-areas: 'inner-nav inner-content';
}

.area-inner-content {
    grid-area: inner-content;
}
</style>
